'use strict';

var React = require('react');
var _ = require('underscore');
var tool = require('../../helper/tool');
var GlobalConst = require('../../types/GlobalConst');
var styleHelper = require('../../helper/styleHelper');

/**
 * 只用于组件边框和背景的呈现，不能用于其他地方
 */

var Border2 = React.createClass({

  protoTypes: {
    className: React.PropTypes.string,
    partStyle: React.PropTypes.object
  },

  initStyle: function () {

    var borderStyle = {
      padding: 0,
      overflow: 'hidden',
      position: 'relative',
      boxSizing: 'border-box',

      left: 0,
      top: 0,
      width: '100%',
      height: '100%',
      backgroundColor: styleHelper.getBackgroundColor(this.props),
      borderColor: styleHelper.getBorderColor(this.props),
      borderWidth: this.props.borderWidth || 1,
      borderStyle: this.props.borderVisible ? 'solid' : 'none',
      borderRadius: this.props.radius || 0
    };

    return tool.extendObj(borderStyle, this.props.partStyle);
  },

  render: function () {
    return (
        <div style={this.initStyle()} key={this.props.key} className={this.props.className || 'Border'} onClick={this.props.onClick}>
            {this.props.children}
        </div>
    );
  }
});


module.exports = Border2;



// WEBPACK FOOTER //
// ./src/views/common/Border.jsx